import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { fetchQnaList } from "../../services/AdminQnaService";

export default function AdminQna() {
  const [qnaList, setQnaList] = useState([]);
  const navigate = useNavigate();
  const token = localStorage.getItem("token");

  useEffect(() => {
  const getQnaList = async () => {
    try {
      const data = await fetchQnaList(token);
      console.log("QNA LIST 응답:", data.qna_list); // 👈 이거 추가
      if (data.success) {
        setQnaList(data.qna_list);
      } else {
        alert("문의사항 데이터를 불러오지 못했습니다.");
      }
    } catch (err) {
      console.error("문의사항 불러오기 실패:", err);
    }
  };
  getQnaList();
}, [token]);


  return (
    <div className="admin">
      <h1>문의사항</h1>
      <div className="admin_box">
        <div className="admin_list">
          <div className="table">
            <table>
              <caption>문의사항 관리</caption>
              <thead>
                <tr>
                  <th>번호</th>
                  <th>제목</th>
                  <th>작성자</th>
                  <th>작성일</th>
                  <th>답변상태</th>
                </tr>
              </thead>
              <tbody>
                {qnaList.length > 0 ? (
                  qnaList.map((item, index) => (
                    <tr
                      key={item.id}
                      onClick={() => navigate(`/adminqna/${item.id}`)}
                      style={{ cursor: "pointer" }}
                    >
                      <td>{index + 1}</td>
                      <td>{item.title}</td>
                      <td>{item.name || "알 수 없음"}</td>
                      <td>{new Date(item.create_date).toLocaleString()}</td>
                      <td>
                        {item.is_replied ? (
                          <span style={{ color: "green", fontWeight: "bold" }}>답변완료</span>
                        ) : (
                          <span style={{ color: "gray" }}>미답변</span>
                        )}
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="5">등록된 문의사항이 없습니다.</td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
}
